module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"abstractSectionTitle":"Om kurset"},"en":{"abstractSectionTitle":"About Course"}}')
  delete Component.options._Ctor
}
